<div #mapWrapper class="ammap-wrapper"></div>
